import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F7F2EB] border-t border-[#E8DFD8] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <p className="font-serif text-2xl text-[#4A362E]">
            Physiotherapie Borghese
          </p>
          <p className="text-[11px] tracking-[0.22em] uppercase text-[#B56553] mt-1">
            Ronnenberg-Empelde
          </p>
          <p className="mt-6 text-sm text-[#5C4E48] max-w-xs leading-relaxed">
            Persönliche, moderne und ganzheitliche Physiotherapie. Zeit für Sie
            und Ihre Beschwerden.
          </p>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase text-[#B56553]">
            Kontakt
          </p>
          <ul className="mt-5 space-y-3 text-sm text-[#5C4E48]">
            <li className="flex items-start gap-3">
              <MapPin size={16} strokeWidth={1.5} className="mt-0.5 text-[#B56553]" />
              <span>
                Bruchstraße 8
                <br />
                30952 Ronnenberg-Empelde
              </span>
            </li>
            <li>
              <a
                href="tel:+4917621684344"
                data-testid="footer-phone-link"
                className="inline-flex items-center gap-3 hover:text-[#B56553] transition-colors"
              >
                <Phone size={16} strokeWidth={1.5} className="text-[#B56553]" />
                0176 21684344
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase text-[#B56553]">
            Rechtliches
          </p>
          <ul className="mt-5 space-y-3 text-sm text-[#5C4E48]">
            <li>
              <Link
                to="/impressum"
                data-testid="footer-impressum-link"
                className="hover:text-[#B56553] transition-colors"
              >
                Impressum
              </Link>
            </li>
            <li>
              <Link
                to="/datenschutz"
                data-testid="footer-datenschutz-link"
                className="hover:text-[#B56553] transition-colors"
              >
                Datenschutz
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#E8DFD8]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#8A7A72]">
            © {new Date().getFullYear()} Physiotherapie Borghese. Alle Rechte
            vorbehalten.
          </p>
          <p className="text-xs text-[#8A7A72]">
            Ronnenberg-Empelde · Region Hannover
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
